<script setup lang="ts">
import { onDeactivated, onUnmounted, ref, watch } from "vue";
import { mapState } from "../../context/context";
import { popRateXg } from "../../globalTeleport";
import RateXg from "./RateXg.vue";
import { INIT, completeRate, type StoredRate } from "./common";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { RateXg },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    editable?: boolean;
    init?: StoredRate;
  }>(),
  {}
);

const emits = defineEmits<{
  (event: "rate", v: StoredRate): void;
}>();

const mappedState = mapState([
  "color.foregroundPattern",
  "color.fontPattern",
  "color.panelPattern"
]);

const editable = ref(props.editable);
const selected = ref(completeRate(props.init));

function rate(v) {
  if (!editable.value) {
    // 不打开 pop
    return;
  }
  popRateXg({
    mode: "all",
    editable: editable.value,
    init: v,
    onConfirm: (newSelected) => {
      selected.value = newSelected;
      editable.value = false;
    },
    onCancel: () => {
      selected.value = {
        ...INIT
      };
    }
  });
}
function throttledClick() {
  if (!editable.value) {
    return;
  }
  // 默认值
  selected.value = completeRate({ rate: 5 });
  rate(selected.value);
}

function destroy() {}

onUnmounted(() => {
  destroy();
});
onDeactivated(() => {
  destroy();
});

defineExpose({});
</script>

<template>
  <div
    class="rate-xg-panel"
    :style="{
      backgroundColor: mappedState['color.foregroundPattern'].value,
      color: mappedState['color.fontPattern'].value
    }"
    @click="throttledClick"
  >
    <div>
      <div class="rate-xg-panel-title">本次停车体验您满意吗？</div>
      <div class="rate-xg-panel-rate">
        <RateXg
          mode="only-status"
          :editable="editable"
          v-model="selected"
          @throttledClick="throttledClick"
          @rate="rate"
        ></RateXg>
      </div>
    </div>
  </div>
</template>

<style scoped>
.rate-xg-panel {
  line-height: 1;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 var(--yz-padding-horizontal, 15px);
}
.rate-xg-panel-title {
  font-size: 16px;
  font-weight: bold;
  padding: var(--yz-padding-horizontal, 15px);
}
.rate-xg-panel-rate {
  padding-bottom: var(--yz-padding-horizontal, 15px);
}
</style>
